/* eslint-disable jsx-a11y/no-autofocus */

import React from 'react'
import styled from 'styled-components'
import { Button, Flex, Text } from 'pcln-design-system'
import ChildrenLineItem from '../ChildrenLineItem'
import TravelerLineItem from '../TravelerLineItem'
import { DEFAULT_MAX_ROOMS, ROOM_SIZE } from '../constants'
import { ITravelerSelectionContent } from '../types'

const PopoverContent = styled(Flex)`
  flex-direction: column;
  font-family: ${(props) => props.theme.font};
`

function TravelerSelectionContent({
  ageSelectEnabled,
  autoFocus,
  borderRadius,
  className,
  disclaimer,
  isChildAgeSeti,
  maxAdults,
  maxChildren,
  roomsEnabled,
  state,
  handleClose,
  subLabelMap,
  lapInfantLabel,
}: ITravelerSelectionContent) {
  const maxRooms =
    ageSelectEnabled && roomsEnabled && maxAdults && maxChildren
      ? Math.ceil((maxAdults + maxChildren) / ROOM_SIZE)
      : DEFAULT_MAX_ROOMS

  return (
    <PopoverContent className={className} px={3}>
      {roomsEnabled && (
        <TravelerLineItem
          autoFocus={autoFocus}
          label='Rooms'
          min={1}
          max={maxRooms}
          count={state.rooms}
          onChange={state.setRooms}
        />
      )}
      <TravelerLineItem
        autoFocus={autoFocus && !roomsEnabled}
        label='Adults'
        subLabel={subLabelMap?.adults || ''}
        min={1}
        max={maxAdults || state.adults + state.remainingTravelerCount}
        count={state.adults}
        onChange={state.setAdults}
      />
      {!ageSelectEnabled && (
        <TravelerLineItem
          label='Youths'
          subLabel={subLabelMap?.youths || '(ages 15-17)'}
          min={0}
          max={state.youths + state.remainingTravelerCount}
          count={state.youths}
          onChange={state.setYouths}
        />
      )}
      <ChildrenLineItem
        ageSelectEnabled={ageSelectEnabled}
        max={maxChildren || state.children + state.remainingTravelerCount}
        count={state.children}
        ages={state.childrenAges}
        onChange={state.setChildren}
        onAgeChange={state.setChildrenAges}
        isChildAgeSeti={isChildAgeSeti}
        subLabel={subLabelMap?.children || '(ages 2-14)'}
      />
      {!ageSelectEnabled && (
        <TravelerLineItem
          label={lapInfantLabel || 'Lap Infants'}
          subLabel={subLabelMap?.lapInfants || '(under 2)'}
          min={0}
          max={state.adults}
          count={state.lapInfants}
          onChange={state.setLapInfants}
        />
      )}
      <Flex flexDirection='column' alignItems='center'>
        <Button borderRadius={borderRadius} width={1} onClick={handleClose} mt={1} mb={3}>
          Done
        </Button>
        {disclaimer && (
          <Text fontSize={0} mx={3} mb={3}>
            {disclaimer}
          </Text>
        )}
      </Flex>
    </PopoverContent>
  )
}

export default TravelerSelectionContent
